import type {
  SuperadminBackgroundTaskInfoDetail,
  TableResultSuperadminBackgroundTaskInfo
} from 'api/models/mainservice';
import { protectedApiClient } from 'api/support/baseApiClients';
import { getUploadHeaders } from 'api/support/helper';
import type { SuperadminBackgroundTaskInfoQuery } from 'pages/admin/companies/components/operations/models';

export default {
  getBackgroundTasks: async (params: SuperadminBackgroundTaskInfoQuery) => {
    const result = await protectedApiClient.get<TableResultSuperadminBackgroundTaskInfo>(
      '/superadmin/managementTools/backgroundTasks',
      { params }
    );

    return result.data;
  },
  getBackgroundTaskDetail: async (taskId: string) => {
    const result = await protectedApiClient.get<SuperadminBackgroundTaskInfoDetail>(
      `/superadmin/managementTools/backgroundTask/${taskId}`
    );

    return result.data;
  },
  abortBackgroundTask: async (taskId: string) => {
    const result = await protectedApiClient.put(
      `/superadmin/managementTools/backgroundTask/${taskId}/abort`
    );
    return result.data;
  },
  startImport: async (importTaskId: string): Promise<void> => {
    await protectedApiClient.post(`/superadmin/import/v2/start-import/${importTaskId}`);
  },
  // Re-runs a terminal/draft import as a brand new import task. The (optional) file is built into
  // the FormData by the caller — when it carries no file the original task's file is reused.
  reimport: async (importTaskId: string, formData: FormData): Promise<void> => {
    await protectedApiClient.post(
      `/superadmin/import/v2/reimport/${importTaskId}`,
      formData,
      getUploadHeaders
    );
  },
  scheduleNextRevisionNotificationsForCompany: async (companyId: string): Promise<void> => {
    await protectedApiClient.post(
      `/superadmin/managementTools/${companyId}/scheduleNextRevisionNotificationsForCompany`
    );
  }
};
